'use strict';

angular.module('atex.dam').controller('DamInstagramController', [ '$scope', '$q', 'DamService', '$translate', 'DamNotificationService',
function($scope, $q, DamService, $translate, DamNotificationService) {

  $scope.panelTitle = $translate.getTranslationTable().__INSTAGRAM_TAGS__;
  $scope.routes = undefined;
  $scope.showSpinner = true;
  $scope.isAdding = false;
  $scope.adding = '';
  
  function getInstagramRoutes() {
    var deferred = $q.defer();
    DamService.getCamelRoutes().then(function(response) {
      var instRoutes = [];
      angular.forEach(response.data, function(route) {
        if (route.toUri === "instagramProcessor") {
          this.push(route);
        }
      }, instRoutes);
      deferred.resolve(instRoutes);
    }).then(null, function(error) {
      console.log("DamService.getCamelRoutes: " + error.type);
      deferred.reject(error);
    });
    return deferred.promise;
  }
  
  $scope.getTagFromUri = function(uri) {
    var parts = uri.split('?');
    if (parts.length!==2) {
      return;
    }
    var queryString = parts[1];
    var splits = queryString.split('&');
    for (var i = 0; i < splits.length; i++) {
        var pair = splits[i].split('=');
        if (pair[0] === 'tag') {
            return pair[1];
        }
    }
  };
  
  getInstagramRoutes().then(function(instRoutes) {
    $scope.routes = instRoutes;
    $scope.showSpinner = false;
  }).then(null, function(error) {
    $scope.showSpinner = false;
  });

  $scope.addInstagramRoute = function() {
    if (!$scope.adding) {
      return;
    }
    $scope.isAdding = true;
    var fromUri = "instagram://search/tag?tag=" + $scope.adding;
    DamService.addCamelRoute(fromUri, "instagramProcessor").then(function(response) {
      $scope.adding = '';
      getInstagramRoutes().then(function(instRoutes) {
        $scope.routes = instRoutes;
        $scope.isAdding = false;
      }).then(null, function(error) {
        $scope.isAdding = false;
      });
    }).then(null, function(error) {
      if (error.status===304) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: 'Route already exists!' }), false);
      } else {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: error.statusText}), true);
      }
      $scope.isAdding = false;
    });
  };
  
  $scope.removeInstagramRoute = function(routeId) {
    $scope.showSpinner = true;
    DamService.removeCamelRoute(routeId).then(function(response) {
      getInstagramRoutes().then(function(instRoutes) {
        $scope.routes = instRoutes;
        $scope.showSpinner = false;
      }).then(null, function(error) {
        $scope.showSpinner = false;
      });
    }).then(null, function(error) {
      console.log("removeInstagramRoutes: " + error.type);
      $scope.showSpinner = false;
    });
  };
  
} ]);
